export const isVisible = (mask: number | null, position: number) => {

  if(!mask) return false

  return (mask & (1 << position)) !== 0
}

export namespace BitMask {
  export function isEnabled(value: number | null, index: number): boolean {
    if (value === null) {
      return false
    } else {
      return (value & (1 << index)) !== 0
    }
  }

  export function on(value: number,index:number): number {
    return value | (1 << index)
  }

  export function off(value: number,index:number): number {
    return value & ~(1 << index)
  }

  export function invert(value: number, index: number): number {
    return value ^ (1 << index)
  }
}